import { Observable } from "rxjs"
import ImportJobData from "../../Administration/CompanyImport/Model/ImportJobData"
import { ObservableFromFetch } from "../../ObservableFromFetch"

export default function ImportJobCreateObservable(csvBase64: string, fileName: string, hasHeaderRow: boolean, companyID: number, isGovtPersonnel?: boolean, poolID?: number, multiplePools: boolean = false): Observable<ImportJobData> {
  const params: string = JSON.stringify({
    CSVFileBase64String: csvBase64,
    FileName: fileName,
    HasHeaderRow: hasHeaderRow,
    UseTemplate: false,
    ImportJobID: 0,
    CompanyID: companyID,
    GovtPersonnel: isGovtPersonnel,
    WorkforcePersonnel: !isGovtPersonnel,
    PoolID: poolID || 0,
    MultiplePools: multiplePools
  })
  return ObservableFromFetch<ImportJobData>("WorkforceImport/CreateImportJob", params)
}
